module.exports = __webpack_public_path__ + "media/images/common/purchase_btn_ov-ad057241c7490874e7341f2e57918b6a.png";